import { axiosEduServer } from "../utils/configAxios";

export const crearDocente = (data) => {
  return axiosEduServer.post('/docente', data).then(({ data }) => data).catch((err) => { throw err });
};

export const actualizarDocente = (id, data) => {
  return axiosEduServer.put(`/docente/${id}`, data).then(({ data }) => data).catch((err) => { throw err });
};

export const eliminarDocente = (id) => {
  return axiosEduServer.delete(`/docente/${id}`).then(({ data }) => data).catch((err) => { throw err });
};

export const getOneDocente = (id) => {
  return axiosEduServer.get(`/docente/${id}`).then(({ data }) => data).catch((err) => { throw err });
};

export const getAllDocentes = () => {
  return axiosEduServer.get('/docente').then(({ data }) => data).catch((err) => { throw err });
};

export const getAllDocentesByIdIdioma = (idIdioma) => {
  return axiosEduServer.get(`/docente/ididioma/${idIdioma}`).then(({ data }) => data).catch((err) => { throw err });
};